//-----------------------------------------------------------------------
// Copyright © 2022 ManpowerGroup. All Rights Reserved.
//-----------------------------------------------------------------------

/* eslint-disable prettier/prettier */
import httpHelper from "../common/helpers/HttpHelper";
import environments from "../common/environments/environment";
const http = new httpHelper();


export const ClientSpecificActions = {
  GetClientSpecificJSON: getClientSpecificJSON,
  GetClientContentList: getClientContentList,
  GetRTPersona: getRTPersona,
  GetRTProgramClass: getRTProgramClass,
  GetRTProgramTemplate: getRTProgramTemplate,
  GetCountriesList: getCountriesList,
  GetClientsList: getClientsList,
  GetCascadeClientData: getCascadeClientData,
  CreateClientContentSave: createClientContentSave,
};

function getClientSpecificJSON() {
    return http.jsonGet(environments.CONTAINER_NAME + environments.CLIENT_SPECIFIC_CONTENT);
}
function getClientContentList() {
    return http.adminGet(environments.CREATE_CLIENT_CONTENT);
}
function createClientContentSave(payload) {
    return http.adminPost(environments.CREATE_CLIENT_CONTENT_SAVE, payload);
}
function getClientsList() {
    return http.adminGet(environments.CLIENT_LIST);
}
function getRTPersona() {
    return http.get(environments.RT_PERSONA);
}

function getCascadeClientData() {
  return http.candidateGet(environments.CascadingClientSpecificData);
}

function getRTProgramClass() {
    return http.get(environments.RT_PROGRAM_CLASS);
}

function getRTProgramTemplate() {
    return http.get(environments.RT_PROGRAM_TEMPLATE);
}

function getCountriesList(locale, key) {
    let refCountry = environments.GET_COUNTRY_LIST.replace("{locale}", locale).replace("{key}", key)
    return http.get(refCountry);
}
